import type { TFunction } from "i18next";
import {
  RenewErrorReasonType,
  SubscriptionStatusType,
} from "@/types/graphql/partner.generated";

/** Подписи статусов подписки: ключи статические (правило i18n кабинета). */
export const SUBSCRIPTION_STATUS_LABEL_KEYS: Readonly<
  Record<SubscriptionStatusType, string>
> = {
  [SubscriptionStatusType.ActiveType]: "subscriptions.status.active",
  [SubscriptionStatusType.PastDueType]: "subscriptions.status.pastDue",
  [SubscriptionStatusType.CanceledType]: "subscriptions.status.canceled",
  [SubscriptionStatusType.ExpiredType]: "subscriptions.status.expired",
};

export const SUBSCRIPTION_STATUS_COLORS: Readonly<
  Record<SubscriptionStatusType, "default" | "success" | "warning" | "error">
> = {
  [SubscriptionStatusType.ActiveType]: "success",
  // Просрочена: продление не прошло, идут повторы списания.
  [SubscriptionStatusType.PastDueType]: "error",
  [SubscriptionStatusType.CanceledType]: "warning",
  [SubscriptionStatusType.ExpiredType]: "default",
};

/** Причина неудачного продления у просроченной подписки. */
export const RENEW_ERROR_REASON_LABEL_KEYS: Readonly<
  Record<RenewErrorReasonType, string>
> = {
  [RenewErrorReasonType.NoPaymentMethodType]:
    "subscriptions.renewError.noPaymentMethod",
  [RenewErrorReasonType.ChargeFailedType]:
    "subscriptions.renewError.chargeFailed",
  [RenewErrorReasonType.InsufficientFundsType]:
    "subscriptions.renewError.insufficientFunds",
  [RenewErrorReasonType.CardExpiredType]:
    "subscriptions.renewError.cardExpired",
  [RenewErrorReasonType.CardDeclinedType]:
    "subscriptions.renewError.cardDeclined",
};

export interface PastDueFields {
  status: SubscriptionStatusType;
  renewAttempts: number;
  nextRenewAttemptAt?: string | null;
  renewDeadlineAt?: string | null;
}

/**
 * Ход просрочки одной строкой: номер попытки и дата следующей, или срок
 * ожидания новой карты, или «платёжная система повторяет сама» (CCBill).
 * null вне просрочки.
 */
export function formatPastDue(
  row: PastDueFields,
  t: TFunction,
  formatDate: (value: string) => string
): string | null {
  if (row.status !== SubscriptionStatusType.PastDueType) return null;
  const attempt = row.renewAttempts;
  if (row.nextRenewAttemptAt) {
    return t("subscriptions.pastDue.attempt", {
      attempt,
      date: formatDate(row.nextRenewAttemptAt),
    });
  }
  if (row.renewDeadlineAt) {
    return t("subscriptions.pastDue.waitingCard", {
      attempt,
      date: formatDate(row.renewDeadlineAt),
    });
  }
  return t("subscriptions.pastDue.providerRetries", { attempt });
}
